import React, { useState, useRef, useContext } from "react";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import { Checkbox } from "@mui/material";

const Index = ({
    title,
    content,
    index,
    item,
    onClicked,
    sections,
    sectionsItem,
    id,
    initial,
    view,
    progress,
    key,
    tab,
    type
}) => {
    const [isOpened, setOpened] = useState(false);
    const [height, setHeight] = useState("0px");
    const contentElement = useRef(null);
    const { theme, changeTheme } = useContext(ThemeContext);

    const HandleOpening = () => {
        setOpened(!isOpened);
        setHeight(!isOpened ? `${contentElement.current.scrollHeight}px` : "0px");
    };

    const scrolltoId = (params) => {
        var access = document.getElementById(params);
        access.scrollIntoView({ behavior: 'smooth' }, true);
    }

    const checkSection = (section, idd) => {
        let find = section?.findIndex((item) => {
            return item.course_section_item_id === idd;
        });
        if (find == -1) {
            return false;
        } else {
            return true;
        }
    };

    const checkSectionD = (section, idd) => {
        let find = section.findIndex((item) => {
            return item.course_section_id === idd;
        });
        if (find == -1) {
            return false;
        } else {
            return true;
        }
    };

    React.useEffect(() => {
        if (initial) {
            var element = document.getElementById("sectTab" + initial);
            // scrolltoId("sectTab" + initial)
            element.style.height = `${element.scrollHeight}px`;
        }
    }, [initial]);

    return (
        <div ref={contentElement}
            id={"sectTab" + item.id} className="section-outline hover_c ">
            <h4 className="tit-section xsm">Section: {item?.title}</h4>
            <ul className="section-list">
                {content?.map((item, index) => {
                    return (
                        <li id={"section_items_" + item.id} className={checkSection(sectionsItem, item.id) ? "cursor-pointer o-view" : " cursor-pointer"} disabled={
                            tab?.item_id == item.id
                                ? false
                                : item.is_required == 1 &&
                                    !checkSection(sectionsItem, item.id)
                                    ? true
                                    : item.is_required == 1 &&
                                        checkSection(sectionsItem, item.id)
                                        ? false
                                        : false
                        }
                            onClick={() => onClicked(item, {
                                            sect_id: id,
                                            item_id: item.id,
                                            item_next: "",
                                        })
                            }>
                            <div className={item.id === view?.id ? "count active_course" : "count"}><span>{index + 1}</span></div>
                            <div className="list-body">
                                <p>
                                    <a>
                                        {item?.title}
                                        <p>{item?.description}</p>
                                    </a>
                                </p>
                                {item?.is_download==="1"&&
                                <div className="download">
                                    <a href={process.env.REACT_APP_API_URL+"/download/resource/"+item.id} target="_blank"><i className="icon mdi2x mdi mdi-download" /></a>
                                    <div className="download-ct">
                                        <span>Download Resource</span>
                                    </div>
                                </div>}
                            </div>
                            <div className="div-x"><i className="icon mdi2x mdi mdi-check-circle" /></div>
                            <div className="line" />
                            {/* <div className={tab?.item_id != item.id || checkSection(sectionsItem, item.id) ? "div-x active_course" : "div-x"}><i className="icon mdi2x mdi mdi-check-circle" /></div> */}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default Index;